// extracted by mini-css-extract-plugin
module.exports = {"targetVideo":"styles_targetVideo__Y0nzb"};